module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "69ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SwatchGroup_vue_vue_type_style_index_0_id_3052149c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b6b8");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SwatchGroup_vue_vue_type_style_index_0_id_3052149c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SwatchGroup_vue_vue_type_style_index_0_id_3052149c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8351":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("adfc");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("37c5ffc6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "901b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Swatch_vue_vue_type_style_index_0_id_17ab44ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8351");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Swatch_vue_vue_type_style_index_0_id_17ab44ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Swatch_vue_vue_type_style_index_0_id_17ab44ba_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9fdf":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "[data-v-3052149c]:root{--black:#000;--white:#fff;--gray-100:#1a1a1a;--gray-90:#313131;--gray-80:#484848;--gray-70:#5f5f5f;--gray-60:#767676;--gray-50:#8d8d8d;--gray-40:#a3a3a3;--gray-30:#bababa;--gray-20:#d1d1d1;--gray-10:#e8e8e8;--gray-05:#f4f4f4;--gray-02:#fafafa;--red-100:#ce1a2b;--red-90:#d33140;--red-20:#f5d1d5;--red-10:#fae8ea;--red-140:#7c101a;--blue-100:#007ab8;--blue-90:#1a87bf;--blue-20:#cce4f1;--blue-10:#e6f2f8;--blue-140:#00496e;--green-100:#45b931;--green-90:#58c046;--green-20:#daf1d6;--green-10:#ecf8ea;--green-140:#296f1d;--orange-100:#f07323;--orange-90:#f28139;--orange-20:#fce3d3;--orange-10:#fef1e9;--orange-140:#904515;--teal-100:#00a8cb;--info:#007ab8;--primary:#007ab8;--secondary:#1a1a1a;--success:#45b931;--warning:#f07323;--alert:#ce1a2b;--error:#ce1a2b;--font-body-regular:Roboto,Arial,Helvetica,sans-serif;--font-heading:Avalon-Bold,Arial,Helvetica,sans-serif;--h-input:calc(2.25rem + 2px);--pdl-color-active:var(--blue-100);--pdl-color-text-link:var(--gray-100);--pdl-color-text-link-disabled:var(--gray-30);--pdl-color-border-tab-active:var(--pdl-color-active);--pdl-transition-duration-75:75ms;--pdl-transition-duration-100:100ms;--pdl-transition-duration-150:150ms;--pdl-transition-duration-200:200ms;--pdl-transition-duration-300:300ms;--pdl-transition-duration-500:500ms;--pdl-transition-duration-700:700ms;--pdl-transition-duration-1000:1000ms;--pdl-transition-timing-function-linear:linear;--pdl-transition-timing-function-ease-in:cubic-bezier(0.4,0,1,1);--pdl-transition-timing-function-ease-out:cubic-bezier(0,0,0.2,1);--pdl-transition-timing-function-ease-in-out:cubic-bezier(0.4,0,0.2,1)}input[type=number][data-v-3052149c]::-webkit-inner-spin-button,input[type=number][data-v-3052149c]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-3052149c]{-moz-appearance:textfield}input[data-v-3052149c]:-ms-input-placeholder,textarea[data-v-3052149c]:-ms-input-placeholder{color:inherit;opacity:.5}input[data-v-3052149c]::placeholder,textarea[data-v-3052149c]::placeholder{color:inherit;opacity:.5}@font-face{font-family:Avalon-Bold;src:url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont#Avalon-Bold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300#Roboto) format(\"svg\");font-weight:300;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular#Roboto) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500#Roboto) format(\"svg\");font-weight:500;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700#Roboto) format(\"svg\");font-weight:700;font-style:normal}@font-face{font-family:SSStandard;src:url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard#SSStandard) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:icomoon;src:url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon#icomoon) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Material Icons;src:url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular#Material%20Icons) format(\"svg\");font-weight:400;font-style:normal}.text--nav[data-v-3052149c]{font-size:1.25rem;line-height:1.25rem}@media only screen and (min-width:64rem){.text--nav[data-v-3052149c]{font-size:.875rem;line-height:1.5rem}}.text--nav-level2[data-v-3052149c]{font-size:.875rem;line-height:1.25rem}@media only screen and (min-width:64rem){.text--nav-level2[data-v-3052149c]{font-size:1rem;line-height:1.5rem}}.text--terra[data-v-3052149c]{font-size:1.875rem;line-height:1.875rem}@media only screen and (min-width:40rem){.text--terra[data-v-3052149c]{font-size:2.8125rem;line-height:2.813rem}}@media only screen and (min-width:64rem){.text--terra[data-v-3052149c]{font-size:3.75rem;line-height:3.75rem}}.text--giga[data-v-3052149c]{font-size:1.5rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--giga[data-v-3052149c]{font-size:1.875rem;line-height:1.563rem}}@media only screen and (min-width:64rem){.text--giga[data-v-3052149c]{font-size:3rem;line-height:3rem}}.text--gaga[data-v-3052149c]{font-size:1.5rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--gaga[data-v-3052149c]{font-size:1.875rem;line-height:1.563rem}}@media only screen and (min-width:64rem){.text--gaga[data-v-3052149c]{font-size:2.5rem;line-height:3rem}}.text--mega[data-v-3052149c]{font-size:1.875rem;line-height:1.875rem}@media only screen and (min-width:40rem){.text--mega[data-v-3052149c]{font-size:1.875rem;line-height:1.875rem}}@media only screen and (min-width:64rem){.text--mega[data-v-3052149c]{font-size:1.875rem;line-height:1.875rem}}.text--kilo[data-v-3052149c]{font-size:.9375rem;line-height:.938rem}@media only screen and (min-width:40rem){.text--kilo[data-v-3052149c]{font-size:1.25rem;line-height:1.25rem}}@media only screen and (min-width:64rem){.text--kilo[data-v-3052149c]{font-size:1.5rem;line-height:1.5rem}}.text--hecto[data-v-3052149c]{font-size:.875rem;line-height:1.125rem}@media only screen and (min-width:40rem){.text--hecto[data-v-3052149c]{font-size:1rem;line-height:1.375rem}}@media only screen and (min-width:64rem){.text--hecto[data-v-3052149c]{font-size:1.125rem;line-height:1.5rem}}.text--deca[data-v-3052149c]{font-size:.9375rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--deca[data-v-3052149c]{font-size:.9375rem;line-height:1.5rem}}@media only screen and (min-width:64rem){.text--deca[data-v-3052149c]{font-size:1rem;line-height:1.5rem}}.text--base[data-v-3052149c]{font-size:.875rem;line-height:1.6rem}@media only screen and (min-width:40rem){.text--base[data-v-3052149c]{font-size:.875rem;line-height:1.6rem}}@media only screen and (min-width:64rem){.text--base[data-v-3052149c]{font-size:.875rem;line-height:1.6rem}}.text--deci[data-v-3052149c]{font-size:.8125rem;line-height:1.25rem}@media only screen and (min-width:40rem){.text--deci[data-v-3052149c]{font-size:.8125rem;line-height:1.25rem}}@media only screen and (min-width:64rem){.text--deci[data-v-3052149c]{font-size:.8125rem;line-height:1.375rem}}.text--centi[data-v-3052149c]{font-size:.6875rem;line-height:1rem}@media only screen and (min-width:40rem){.text--centi[data-v-3052149c]{font-size:.6875rem;line-height:1rem}}@media only screen and (min-width:64rem){.text--centi[data-v-3052149c]{font-size:.6875rem;line-height:1rem}}.heading[data-v-3052149c]{font-family:Avalon-Bold,Arial,Helvetica,sans-serif;line-height:1.2}.disable-responsive-font-size .heading--xl[data-v-3052149c],.heading--xl[data-v-3052149c],.heading--xl.disable-responsive-font-size[data-v-3052149c]{font-size:2.625rem}@media (max-width:1200px){.heading--xl[data-v-3052149c]{font-size:calc(1.325rem + 1.73333vw)}}.disable-responsive-font-size .heading--lg[data-v-3052149c],.heading--lg[data-v-3052149c],.heading--lg.disable-responsive-font-size[data-v-3052149c]{font-size:2.125rem}@media (max-width:1200px){.heading--lg[data-v-3052149c]{font-size:calc(1.225rem + 1.2vw)}}.disable-responsive-font-size .heading--md[data-v-3052149c],.heading--md[data-v-3052149c],.heading--md.disable-responsive-font-size[data-v-3052149c]{font-size:1.5rem}@media (max-width:1200px){.heading--md[data-v-3052149c]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .heading--sm[data-v-3052149c],.heading--sm[data-v-3052149c],.heading--sm.disable-responsive-font-size[data-v-3052149c]{font-size:1.125rem}@media (max-width:1200px){.heading--sm[data-v-3052149c]{font-size:calc(1.025rem + .13333vw)}}.section-header .heading[data-v-3052149c]{margin-top:0;margin-bottom:0}.section-header--lg .heading[data-v-3052149c],.section-header--xl .heading[data-v-3052149c]{font-size:inherit}.disable-responsive-font-size .section-header--md .heading[data-v-3052149c],.section-header--md .heading[data-v-3052149c],.section-header--md .heading.disable-responsive-font-size[data-v-3052149c]{font-size:1.5rem}@media (max-width:1200px){.section-header--md .heading[data-v-3052149c]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .section-header--sm .heading[data-v-3052149c],.section-header--sm .heading[data-v-3052149c],.section-header--sm .heading.disable-responsive-font-size[data-v-3052149c]{font-size:1.125rem}@media (max-width:1200px){.section-header--sm .heading[data-v-3052149c]{font-size:calc(1.025rem + .13333vw)}}.disable-responsive-font-size .subheading--xl[data-v-3052149c],.subheading--xl[data-v-3052149c],.subheading--xl.disable-responsive-font-size[data-v-3052149c]{font-size:1.5rem}@media (max-width:1200px){.subheading--xl[data-v-3052149c]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .subheading--lg[data-v-3052149c],.subheading--lg[data-v-3052149c],.subheading--lg.disable-responsive-font-size[data-v-3052149c]{font-size:1.125rem}@media (max-width:1200px){.subheading--lg[data-v-3052149c]{font-size:calc(1.025rem + .13333vw)}}.subheading--md[data-v-3052149c]{font-size:1rem}.subheading--sm[data-v-3052149c]{font-size:.875rem}.disable-responsive-font-size .section-header--xl .subheading[data-v-3052149c],.section-header--xl .subheading[data-v-3052149c],.section-header--xl .subheading.disable-responsive-font-size[data-v-3052149c]{font-size:1.5rem}@media (max-width:1200px){.section-header--xl .subheading[data-v-3052149c]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .section-header--lg .subheading[data-v-3052149c],.section-header--lg .subheading[data-v-3052149c],.section-header--lg .subheading.disable-responsive-font-size[data-v-3052149c]{font-size:1.125rem}@media (max-width:1200px){.section-header--lg .subheading[data-v-3052149c]{font-size:calc(1.025rem + .13333vw)}}.section-header--md .subheading[data-v-3052149c]{font-size:1rem}.section-header--sm .subheading[data-v-3052149c]{font-size:.875rem}.heading+.subheading[data-v-3052149c]{margin-top:.33em}.section-header .subheading[data-v-3052149c]{margin-bottom:0}.pdl-swatches[data-v-3052149c]{--swatch-items-across:6;--swatch-outer-dimensions:1.5em;--swatch-size:1.875rem;--swatch-margin:0.5rem;display:flex;flex-flow:row wrap;max-width:calc(var(--swatch-items-across)*(var(--swatch-size) + var(--swatch-margin)));min-height:var(--swatch-outer-dimensions)}.pdl-swatch-container[data-v-3052149c]{display:flex;position:relative;margin-bottom:var(--swatch-margin)}.pdl-swatch-container[data-v-3052149c]:not(:last-child){margin-right:var(--swatch-margin)}.pdl-swatch__radio[data-v-3052149c]{position:absolute;opacity:0;z-index:-1;width:100%;height:100%}.pdl-swatch__radio:checked~.pdl-swatch[data-v-3052149c]{border-color:var(--gray-100)}.pdl-swatch__radio:focus~.pdl-swatch[data-v-3052149c]{box-shadow:0 0 0 .125em rgba(0,122,184,.3);transform:scale(1.2)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "adfc":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "[data-v-17ab44ba]:root{--black:#000;--white:#fff;--gray-100:#1a1a1a;--gray-90:#313131;--gray-80:#484848;--gray-70:#5f5f5f;--gray-60:#767676;--gray-50:#8d8d8d;--gray-40:#a3a3a3;--gray-30:#bababa;--gray-20:#d1d1d1;--gray-10:#e8e8e8;--gray-05:#f4f4f4;--gray-02:#fafafa;--red-100:#ce1a2b;--red-90:#d33140;--red-20:#f5d1d5;--red-10:#fae8ea;--red-140:#7c101a;--blue-100:#007ab8;--blue-90:#1a87bf;--blue-20:#cce4f1;--blue-10:#e6f2f8;--blue-140:#00496e;--green-100:#45b931;--green-90:#58c046;--green-20:#daf1d6;--green-10:#ecf8ea;--green-140:#296f1d;--orange-100:#f07323;--orange-90:#f28139;--orange-20:#fce3d3;--orange-10:#fef1e9;--orange-140:#904515;--teal-100:#00a8cb;--info:#007ab8;--primary:#007ab8;--secondary:#1a1a1a;--success:#45b931;--warning:#f07323;--alert:#ce1a2b;--error:#ce1a2b;--font-body-regular:Roboto,Arial,Helvetica,sans-serif;--font-heading:Avalon-Bold,Arial,Helvetica,sans-serif;--h-input:calc(2.25rem + 2px);--pdl-color-active:var(--blue-100);--pdl-color-text-link:var(--gray-100);--pdl-color-text-link-disabled:var(--gray-30);--pdl-color-border-tab-active:var(--pdl-color-active);--pdl-transition-duration-75:75ms;--pdl-transition-duration-100:100ms;--pdl-transition-duration-150:150ms;--pdl-transition-duration-200:200ms;--pdl-transition-duration-300:300ms;--pdl-transition-duration-500:500ms;--pdl-transition-duration-700:700ms;--pdl-transition-duration-1000:1000ms;--pdl-transition-timing-function-linear:linear;--pdl-transition-timing-function-ease-in:cubic-bezier(0.4,0,1,1);--pdl-transition-timing-function-ease-out:cubic-bezier(0,0,0.2,1);--pdl-transition-timing-function-ease-in-out:cubic-bezier(0.4,0,0.2,1)}input[type=number][data-v-17ab44ba]::-webkit-inner-spin-button,input[type=number][data-v-17ab44ba]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-17ab44ba]{-moz-appearance:textfield}input[data-v-17ab44ba]:-ms-input-placeholder,textarea[data-v-17ab44ba]:-ms-input-placeholder{color:inherit;opacity:.5}input[data-v-17ab44ba]::placeholder,textarea[data-v-17ab44ba]::placeholder{color:inherit;opacity:.5}@font-face{font-family:Avalon-Bold;src:url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/TR-Avalon-Bold-webfont#Avalon-Bold) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-300#Roboto) format(\"svg\");font-weight:300;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-regular#Roboto) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-500#Roboto) format(\"svg\");font-weight:500;font-style:normal}@font-face{font-family:Roboto;src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/roboto-v18-latin-700#Roboto) format(\"svg\");font-weight:700;font-style:normal}@font-face{font-family:SSStandard;src:url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/ss-standard#SSStandard) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:icomoon;src:url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/icomoon#icomoon) format(\"svg\");font-weight:400;font-style:normal}@font-face{font-family:Material Icons;src:url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.eot);src:url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.eot#iefix) format(\"embedded-opentype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.woff2) format(\"woff2\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.woff) format(\"woff\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular.ttf) format(\"truetype\"),url(//trekcdnprod.azureedge.net/hybris/fonts/MaterialIcons-Regular#Material%20Icons) format(\"svg\");font-weight:400;font-style:normal}.text--nav[data-v-17ab44ba]{font-size:1.25rem;line-height:1.25rem}@media only screen and (min-width:64rem){.text--nav[data-v-17ab44ba]{font-size:.875rem;line-height:1.5rem}}.text--nav-level2[data-v-17ab44ba]{font-size:.875rem;line-height:1.25rem}@media only screen and (min-width:64rem){.text--nav-level2[data-v-17ab44ba]{font-size:1rem;line-height:1.5rem}}.text--terra[data-v-17ab44ba]{font-size:1.875rem;line-height:1.875rem}@media only screen and (min-width:40rem){.text--terra[data-v-17ab44ba]{font-size:2.8125rem;line-height:2.813rem}}@media only screen and (min-width:64rem){.text--terra[data-v-17ab44ba]{font-size:3.75rem;line-height:3.75rem}}.text--giga[data-v-17ab44ba]{font-size:1.5rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--giga[data-v-17ab44ba]{font-size:1.875rem;line-height:1.563rem}}@media only screen and (min-width:64rem){.text--giga[data-v-17ab44ba]{font-size:3rem;line-height:3rem}}.text--gaga[data-v-17ab44ba]{font-size:1.5rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--gaga[data-v-17ab44ba]{font-size:1.875rem;line-height:1.563rem}}@media only screen and (min-width:64rem){.text--gaga[data-v-17ab44ba]{font-size:2.5rem;line-height:3rem}}.text--mega[data-v-17ab44ba]{font-size:1.875rem;line-height:1.875rem}@media only screen and (min-width:40rem){.text--mega[data-v-17ab44ba]{font-size:1.875rem;line-height:1.875rem}}@media only screen and (min-width:64rem){.text--mega[data-v-17ab44ba]{font-size:1.875rem;line-height:1.875rem}}.text--kilo[data-v-17ab44ba]{font-size:.9375rem;line-height:.938rem}@media only screen and (min-width:40rem){.text--kilo[data-v-17ab44ba]{font-size:1.25rem;line-height:1.25rem}}@media only screen and (min-width:64rem){.text--kilo[data-v-17ab44ba]{font-size:1.5rem;line-height:1.5rem}}.text--hecto[data-v-17ab44ba]{font-size:.875rem;line-height:1.125rem}@media only screen and (min-width:40rem){.text--hecto[data-v-17ab44ba]{font-size:1rem;line-height:1.375rem}}@media only screen and (min-width:64rem){.text--hecto[data-v-17ab44ba]{font-size:1.125rem;line-height:1.5rem}}.text--deca[data-v-17ab44ba]{font-size:.9375rem;line-height:1.5rem}@media only screen and (min-width:40rem){.text--deca[data-v-17ab44ba]{font-size:.9375rem;line-height:1.5rem}}@media only screen and (min-width:64rem){.text--deca[data-v-17ab44ba]{font-size:1rem;line-height:1.5rem}}.text--base[data-v-17ab44ba]{font-size:.875rem;line-height:1.6rem}@media only screen and (min-width:40rem){.text--base[data-v-17ab44ba]{font-size:.875rem;line-height:1.6rem}}@media only screen and (min-width:64rem){.text--base[data-v-17ab44ba]{font-size:.875rem;line-height:1.6rem}}.text--deci[data-v-17ab44ba]{font-size:.8125rem;line-height:1.25rem}@media only screen and (min-width:40rem){.text--deci[data-v-17ab44ba]{font-size:.8125rem;line-height:1.25rem}}@media only screen and (min-width:64rem){.text--deci[data-v-17ab44ba]{font-size:.8125rem;line-height:1.375rem}}.text--centi[data-v-17ab44ba]{font-size:.6875rem;line-height:1rem}@media only screen and (min-width:40rem){.text--centi[data-v-17ab44ba]{font-size:.6875rem;line-height:1rem}}@media only screen and (min-width:64rem){.text--centi[data-v-17ab44ba]{font-size:.6875rem;line-height:1rem}}.heading[data-v-17ab44ba]{font-family:Avalon-Bold,Arial,Helvetica,sans-serif;line-height:1.2}.disable-responsive-font-size .heading--xl[data-v-17ab44ba],.heading--xl[data-v-17ab44ba],.heading--xl.disable-responsive-font-size[data-v-17ab44ba]{font-size:2.625rem}@media (max-width:1200px){.heading--xl[data-v-17ab44ba]{font-size:calc(1.325rem + 1.73333vw)}}.disable-responsive-font-size .heading--lg[data-v-17ab44ba],.heading--lg[data-v-17ab44ba],.heading--lg.disable-responsive-font-size[data-v-17ab44ba]{font-size:2.125rem}@media (max-width:1200px){.heading--lg[data-v-17ab44ba]{font-size:calc(1.225rem + 1.2vw)}}.disable-responsive-font-size .heading--md[data-v-17ab44ba],.heading--md[data-v-17ab44ba],.heading--md.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.5rem}@media (max-width:1200px){.heading--md[data-v-17ab44ba]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .heading--sm[data-v-17ab44ba],.heading--sm[data-v-17ab44ba],.heading--sm.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.125rem}@media (max-width:1200px){.heading--sm[data-v-17ab44ba]{font-size:calc(1.025rem + .13333vw)}}.section-header .heading[data-v-17ab44ba]{margin-top:0;margin-bottom:0}.section-header--lg .heading[data-v-17ab44ba],.section-header--xl .heading[data-v-17ab44ba]{font-size:inherit}.disable-responsive-font-size .section-header--md .heading[data-v-17ab44ba],.section-header--md .heading[data-v-17ab44ba],.section-header--md .heading.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.5rem}@media (max-width:1200px){.section-header--md .heading[data-v-17ab44ba]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .section-header--sm .heading[data-v-17ab44ba],.section-header--sm .heading[data-v-17ab44ba],.section-header--sm .heading.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.125rem}@media (max-width:1200px){.section-header--sm .heading[data-v-17ab44ba]{font-size:calc(1.025rem + .13333vw)}}.disable-responsive-font-size .subheading--xl[data-v-17ab44ba],.subheading--xl[data-v-17ab44ba],.subheading--xl.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.5rem}@media (max-width:1200px){.subheading--xl[data-v-17ab44ba]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .subheading--lg[data-v-17ab44ba],.subheading--lg[data-v-17ab44ba],.subheading--lg.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.125rem}@media (max-width:1200px){.subheading--lg[data-v-17ab44ba]{font-size:calc(1.025rem + .13333vw)}}.subheading--md[data-v-17ab44ba]{font-size:1rem}.subheading--sm[data-v-17ab44ba]{font-size:.875rem}.disable-responsive-font-size .section-header--xl .subheading[data-v-17ab44ba],.section-header--xl .subheading[data-v-17ab44ba],.section-header--xl .subheading.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.5rem}@media (max-width:1200px){.section-header--xl .subheading[data-v-17ab44ba]{font-size:calc(1.1rem + .53333vw)}}.disable-responsive-font-size .section-header--lg .subheading[data-v-17ab44ba],.section-header--lg .subheading[data-v-17ab44ba],.section-header--lg .subheading.disable-responsive-font-size[data-v-17ab44ba]{font-size:1.125rem}@media (max-width:1200px){.section-header--lg .subheading[data-v-17ab44ba]{font-size:calc(1.025rem + .13333vw)}}.section-header--md .subheading[data-v-17ab44ba]{font-size:1rem}.section-header--sm .subheading[data-v-17ab44ba]{font-size:.875rem}.heading+.subheading[data-v-17ab44ba]{margin-top:.33em}.section-header .subheading[data-v-17ab44ba]{margin-bottom:0}.pdl-swatch-black[data-v-17ab44ba]{fill:#000}.pdl-swatch-blue[data-v-17ab44ba]{fill:#006db3}.pdl-swatch-bluedark[data-v-17ab44ba]{fill:#002f4d}.pdl-swatch-bluelight[data-v-17ab44ba]{fill:#d5eeff}.pdl-swatch-bronze[data-v-17ab44ba]{fill:#a2613d}.pdl-swatch-brown[data-v-17ab44ba]{fill:#77451d}.pdl-swatch-gold[data-v-17ab44ba]{fill:#cdad00}.pdl-swatch-green[data-v-17ab44ba]{fill:#4fb33b}.pdl-swatch-greenlight[data-v-17ab44ba]{fill:#ddf2d8}.pdl-swatch-greendark[data-v-17ab44ba]{fill:#224d19}.pdl-swatch-greenvisibility[data-v-17ab44ba]{fill:#7fff00}.pdl-swatch-grey[data-v-17ab44ba]{fill:#999}.pdl-swatch-greydark[data-v-17ab44ba]{fill:#333}.pdl-swatch-greylight[data-v-17ab44ba]{fill:#ccc}.pdl-swatch-orange[data-v-17ab44ba]{fill:#ff7727}.pdl-swatch-orangelight[data-v-17ab44ba]{fill:#ffc29e}.pdl-swatch-orangevisibility[data-v-17ab44ba]{fill:#ff5200}.pdl-swatch-pink[data-v-17ab44ba]{fill:#ef95b3}.pdl-swatch-pinkdark[data-v-17ab44ba]{fill:#af1a4c}.pdl-swatch-pinklight[data-v-17ab44ba]{fill:#fadfe8}.pdl-swatch-pinkvisibility[data-v-17ab44ba]{fill:#ff1493}.pdl-swatch-purple[data-v-17ab44ba]{fill:#8b4fb3}.pdl-swatch-purpledark[data-v-17ab44ba]{fill:#422555}.pdl-swatch-purplelight[data-v-17ab44ba]{fill:#e1d1eb}.pdl-swatch-red[data-v-17ab44ba]{fill:#d71729}.pdl-swatch-reddark[data-v-17ab44ba]{fill:#6c0c15}.pdl-swatch-redlight[data-v-17ab44ba]{fill:#fc6a6c}.pdl-swatch-reflective[data-v-17ab44ba]{fill:#e5e5e5}.pdl-swatch-tan[data-v-17ab44ba]{fill:tan}.pdl-swatch-teal[data-v-17ab44ba]{fill:#13b3b3}.pdl-swatch-tealdark[data-v-17ab44ba]{fill:#095757}.pdl-swatch-white[data-v-17ab44ba]{fill:#fff}.pdl-swatch-yellow[data-v-17ab44ba]{fill:#fff100}.pdl-swatch-yellowlight[data-v-17ab44ba]{fill:#fff999}.pdl-swatch-yellowvisibility[data-v-17ab44ba]{fill:#defd35}.pdl-swatch[data-v-17ab44ba]{--swatch-border-width:2px;--swatch-size:1.875rem;display:flex;padding:1px;background:var(--white);border-radius:50%;border:var(--swatch-border-width) solid var(--gray-20);-webkit-user-select:none;-ms-user-select:none;user-select:none;width:var(--swatch-size);height:var(--swatch-size);align-items:center;justify-content:center}.pdl-swatch--small[data-v-17ab44ba]{width:calc(var(--swatch-size)*0.667);height:calc(var(--swatch-size)*0.667)}.pdl-swatch--large[data-v-17ab44ba]{width:calc(var(--swatch-size)*1.3334);height:calc(var(--swatch-size)*1.3334)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b6b8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9fdf");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ce9099fc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "PdlSwatch", function() { return /* reexport */ Swatch; });
__webpack_require__.d(__webpack_exports__, "PdlSwatchGroup", function() { return /* reexport */ SwatchGroup; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"35dfc71a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/swatch/src/Swatch.vue?vue&type=template&id=17ab44ba&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sizeClass},[(_vm.imageUrl)?_c('img',{staticClass:"rounded-full",attrs:{"src":_vm.imageUrl}}):_c('svg',{staticClass:"h-auto",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200","viewBox":"0 0 100 100"}},[_c('path',{class:("pdl-swatch-" + _vm.firstColor),attrs:{"d":"M50 0C22.4 0 0 22.4 0 50h100C100 22.4 77.6 0 50 0z"}}),_c('path',{class:_vm.secondColor ? ("pdl-swatch-" + _vm.secondColor) : ("pdl-swatch-" + _vm.firstColor),attrs:{"d":"M50 100C22.4 100 0 77.6 0 50h100C100 77.6 77.6 100 50 100z"}})])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/swatch/src/Swatch.vue?vue&type=template&id=17ab44ba&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/swatch/src/Swatch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Swatchvue_type_script_lang_js_ = ({
  name: 'PdlSwatch',
  props: {
    /**
     * This prop is required when an imageUrl is used. It's optional otherwise.
     *
     * It must be a string without spaces or special characters (i.e. 'blue', 'black_teal').
     * If provided it will be used as the plain text name for the
     * aria label, qaid, input id, etc.
     *
     * If not provided then other strings will be used for this purpose following this priority order:
     *
     * name -> firstcolor_secondcolor -> firstcolor -> Option index
     */
    name: {
      type: String,
      default: null
    },

    /**
     * The first color of a swatch.
     * If secondColor is not provided this color will fill the entire swatch.
     */
    firstColor: {
      type: String,
      default: null
    },

    /**
     * The second color of a swatch.
     * If provided then this color will fill the bottom half of the swatch
     * and firstColor will fill the upper half.
     */
    secondColor: {
      type: String,
      default: null
    },

    /**
     * The image that will fill the swatch.
     * If provided then the image will override the color names provided if any.
     * Ensure that the image is appropriately sized before passing it into the swatch.
     * For reference, the default swatch is 1.875 rem (~24x24px).
     */
    imageUrl: {
      type: String,
      default: null
    },

    /**
     * Displays a smaller swatch.
     */
    isSmall: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * Displays a larger swatch.
     */
    isLarge: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    sizeClass: function sizeClass() {
      return "pdl-swatch".concat(this.isSmall ? ' pdl-swatch--small' : this.isLarge ? ' pdl-swatch--large' : '');
    }
  },
  watch: {
    imageUrl: {
      immediate: true,
      handler: function handler() {
        if (this.imageUrl && !this.name) {
          throw new TypeError('Name is required when using the imageURL prop.');
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/swatch/src/Swatch.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_Swatchvue_type_script_lang_js_ = (Swatchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/swatch/src/Swatch.vue?vue&type=style&index=0&id=17ab44ba&lang=scss&scoped=true&
var Swatchvue_type_style_index_0_id_17ab44ba_lang_scss_scoped_true_ = __webpack_require__("901b");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/swatch/src/Swatch.vue






/* normalize component */

var component = normalizeComponent(
  src_Swatchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "17ab44ba",
  null
  
)

/* harmony default export */ var Swatch = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"35dfc71a-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/swatch/src/SwatchGroup.vue?vue&type=template&id=3052149c&scoped=true&
var SwatchGroupvue_type_template_id_3052149c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pdl-swatches"},_vm._l((_vm.computedOptions),function(option,index){return _c('li',{key:index,staticClass:"pdl-swatch-container"},[_c('label',{attrs:{"qaid":("color-swatch-label-" + (_vm.getOptionId(option, index))),"for":(_vm.radioName + "-swatch-" + (_vm.getOptionId(option, index))),"title":_vm.getOptionId(option, index)}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active),expression:"active"}],staticClass:"pdl-swatch__radio",attrs:{"id":(_vm.radioName + "-swatch-" + (_vm.getOptionId(option, index))),"type":"radio","aria-label":((_vm.getOptionId(option, index)) + " swatch"),"data-color":_vm.getOptionId(option, index),"data-id":"#","data-url":"#","name":_vm.radioName,"disabled":_vm.isDisplayOnly},domProps:{"value":option,"checked":_vm._q(_vm.active,option)},on:{"change":[function($event){_vm.active=option},_vm.onChange]}}),_c('swatch',{class:_vm.cursorClass,attrs:{"is-small":_vm.isSmall,"is-large":_vm.isLarge,"first-color":option.firstColor,"second-color":option.secondColor,"image-url":option.imageUrl,"name":option.name}})],1)])}),0)}
var SwatchGroupvue_type_template_id_3052149c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/swatch/src/SwatchGroup.vue?vue&type=template&id=3052149c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/swatch/src/SwatchGroup.vue?vue&type=script&lang=js&
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SwatchGroupvue_type_script_lang_js_ = ({
  name: 'PdlSwatchGroup',
  components: {
    Swatch: Swatch
  },
  props: {
    /**
     * Disables selection of swatches in group.
     */
    isDisplayOnly: {
      type: Boolean,
      default: false
    },

    /**
     * A callback function to be called when a new swatch is selected
     */
    changeCallback: {
      type: Function,
      default: function _default() {
        return true;
      }
    },

    /**
     * Pre-selects an option in the given `options` prop array. Optional.
     */
    initialSelectedOption: {
      type: Object,
      default: function _default() {}
    },

    /**
     * An array of `swatch` options. See 'Swatch' for possible `option` attributes.
     */
    options: {
      type: Array,
      required: true
    },

    /**
     * The name to be given to the radio group
     */
    radioName: {
      type: String,
      required: true
    },

    /**
     * If true, a smaller version of the swatches will be displayed.
     */
    isSmall: {
      type: Boolean,
      required: false,
      default: false
    },

    /**
     * If true, a larger version of the swatches will be displayed.
     */
    isLarge: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    var _this$initialSelected, _this$initialSelected2;

    return {
      active: _objectSpread(_objectSpread({}, this.initialSelectedOption), {}, {
        radioName: (_this$initialSelected = (_this$initialSelected2 = this.initialSelectedOption) === null || _this$initialSelected2 === void 0 ? void 0 : _this$initialSelected2.radioName) !== null && _this$initialSelected !== void 0 ? _this$initialSelected : this.radioName
      })
    };
  },
  computed: {
    cursorClass: function cursorClass() {
      return this.isDisplayOnly ? 'cursor-default' : 'cursor-pointer';
    },
    computedOptions: function computedOptions() {
      var _this = this;

      return this.options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          radioName: _this.radioName
        });
      });
    }
  },
  watch: {
    initialSelectedOption: function initialSelectedOption(newSelectedOption) {
      this.active = newSelectedOption;
    }
  },
  mounted: function mounted() {
    this.onChange();
  },
  methods: {
    onChange: function onChange() {
      if (typeof this.changeCallback === 'function') {
        this.changeCallback(this.active);
      }
      /**
       * Emitted when the active swatch is changed.
       */


      this.$emit('color-changed', _objectSpread(_objectSpread({}, this.active), {}, {
        radioName: this.radioName
      }));
    },
    getOptionId: function getOptionId(option, index) {
      if (option !== null && option !== void 0 && option.name) return option.name;
      if (option !== null && option !== void 0 && option.firstColor && option !== null && option !== void 0 && option.secondColor) return "".concat(option.firstColor, "-").concat(option.secondColor);
      if (option !== null && option !== void 0 && option.firstColor) return option.firstColor;
      return index;
    }
  }
});
// CONCATENATED MODULE: ./src/components/swatch/src/SwatchGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SwatchGroupvue_type_script_lang_js_ = (SwatchGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/swatch/src/SwatchGroup.vue?vue&type=style&index=0&id=3052149c&lang=scss&scoped=true&
var SwatchGroupvue_type_style_index_0_id_3052149c_lang_scss_scoped_true_ = __webpack_require__("69ee");

// CONCATENATED MODULE: ./src/components/swatch/src/SwatchGroup.vue






/* normalize component */

var SwatchGroup_component = normalizeComponent(
  src_SwatchGroupvue_type_script_lang_js_,
  SwatchGroupvue_type_template_id_3052149c_scoped_true_render,
  SwatchGroupvue_type_template_id_3052149c_scoped_true_staticRenderFns,
  false,
  null,
  "3052149c",
  null
  
)

/* harmony default export */ var SwatchGroup = (SwatchGroup_component.exports);
// CONCATENATED MODULE: ./src/components/swatch/index.js



// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ })

/******/ });
//# sourceMappingURL=pdl-swatch.common.js.map